module.exports = __webpack_public_path__ + "static/media/our_feishu.5b7efe03.png";